import { AccountLOB } from '@ally/data-types-afg-accounts';
import { createSelector } from 'reselect';
import { getDomainData } from './selectors';
/**
 * Returns all auto accounts or an empty array.
 */
var getAllAutoAccounts = createSelector(getDomainData, function (domain) { var _a, _b; return (_b = (_a = domain === null || domain === void 0 ? void 0 : domain.data) === null || _a === void 0 ? void 0 : _a.filter(function (account) { return account.lob === AccountLOB.AUTO; })) !== null && _b !== void 0 ? _b : []; });
export default {
    getAll: getAllAutoAccounts,
};
//# sourceMappingURL=auto.js.map